export const underscoreToCamelCase = (str: string): string => {
  if (!str) return;
  return str.toLowerCase().replace(/_+(\w|$)/g, (_, s) => {
    return s.toUpperCase();
  });
};
